import React from 'react'
import RiskPointMarker from './RiskPointMarker'
import MixerTruckProhibitedRouteMarker from './MixerTruckProhibitedRouteMarker'

const isParkingShoulder = v =>
  v === 'Parking on the road shoulder' || v === 'ParkingLot'

const isNoParking = v => v === 'No Parking' || v === 'NoParking'

const isRiskPoint = v => v === 'Risk Point' || v === 'RiskPoint'

const isMixerTruckProhibitedRoute = v =>
  v === 'Mixer Truck Prohibited Route' || v === 'MixerTruckProhibitedRoute'

const ICON_WIDTH = 35
const ICON_HEIGHT = 42

const IconMarkerNewStyle = ({ cpac_policy_type_name }) => {
  const key = cpac_policy_type_name

  if (isRiskPoint(key)) {
    return <RiskPointMarker width={ICON_WIDTH} height={ICON_HEIGHT} />
  }

  if (isMixerTruckProhibitedRoute(key)) {
    return (
      <MixerTruckProhibitedRouteMarker
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
      />
    )
  }

  const src = isParkingShoulder(key)
    ? '/img/pngmarker/Group 18560-1.png'
    : isNoParking(key)
    ? '/img/pngmarker/Group 18558-1.png'
    : '/img/pngmarker/Group 18558.png'

  return (
    <img
      src={src}
      width={ICON_WIDTH}
      height={ICON_HEIGHT}
      style={{
        width: ICON_WIDTH,
        height: ICON_HEIGHT,
        display: 'block',
      }}
    />
  )
}

export default IconMarkerNewStyle
